import { render, staticRenderFns } from "./CorrectOrderContent.vue?vue&type=template&id=d10a5b00&scoped=true&"
import script from "./CorrectOrderContent.vue?vue&type=script&lang=js&"
export * from "./CorrectOrderContent.vue?vue&type=script&lang=js&"
import style0 from "./CorrectOrderContent.vue?vue&type=style&index=0&id=d10a5b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10a5b00",
  null
  
)

export default component.exports